var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20911 0.921875C3.79036 0.921875 0.209106 4.50313 0.209106 8.92188C0.209106 13.3406 3.79036 16.9219 8.20911 16.9219C12.6279 16.9219 16.2091 13.3406 16.2091 8.92188C16.2091 4.50313 12.6279 0.921875 8.20911 0.921875ZM8.20911 15.9219C4.34973 15.9219 1.20911 12.7812 1.20911 8.92188C1.20911 5.0625 4.34973 1.92188 8.20911 1.92188C12.0685 1.92188 15.2091 5.0625 15.2091 8.92188C15.2091 12.7812 12.0685 15.9219 8.20911 15.9219ZM8.20911 6.67188C8.62317 6.67188 8.95911 6.33625 8.95911 5.92188C8.95911 5.50781 8.62317 5.17188 8.20911 5.17188C7.79504 5.17188 7.45911 5.50625 7.45911 5.92188C7.45911 6.3375 7.79348 6.67188 8.20911 6.67188ZM9.70911 11.9219H8.70911V8.42188C8.70911 8.14687 8.48411 7.92188 8.20911 7.92188H7.20911C6.93411 7.92188 6.70911 8.14687 6.70911 8.42188C6.70911 8.69688 6.93411 8.92188 7.20911 8.92188H7.70911V11.9219H6.70911C6.43411 11.9219 6.20911 12.1469 6.20911 12.4219C6.20911 12.6969 6.43411 12.9219 6.70911 12.9219H9.70911C9.98523 12.9219 10.2091 12.698 10.2091 12.4219C10.2091 12.1469 9.98411 11.9219 9.70911 11.9219Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.44a1d348ee60658f7e7ce2bc593bc459.svg";
export { ForwardRef as ReactComponent };